/* eslint no-template-curly-in-string: "off" */
export const ValidationConstants = {
  // Initialise alpha conversion table omitting O and I as these are not allowed
  // in HPI nos & NHI issued by MOH in NZ. A=1~Z=24
  alphaTableForNzMOH: "ABCDEFGHJKLMNPQRSTUVWXYZ".split("")
};
